export default __webpack_public_path__ + "static/020c2685992097dba94501ea92075d15.jpg";